<template>
  <div>   
	<div class="box" style="margin: 20px auto;">
		<div class="box_list">	  
				<img class="box_list_lfimg" :src="infos.goods_image" />
				<div class="box_list_rt">
					<div class="list_rt_tit">{{infos.goods_name}}</div>
					<div class="list_rt_txt">${{infos.goods_price}}</div>
				</div>		
				<div class="box_list_foot">
					<!-- <span class="list_foot_btn1">{{ $t('Share page') }}</span> -->
					<span class="list_foot_btn2 cursor" @click="jumpShareList">{{ $t('Audit result') }}</span>
					<div class="list_foot_fx">
						{{ $t('Share to the community') }} <img class="cursor" @click="clickShareModel" src="../../../assets/image/giftcard/imsharefxicons.png" />
					</div>
				</div>
		</div>
		<div class="box_tit">{{$t('imshares1')}}</div>
		<div class="box_txt">{{$t('imshares2')}}</div>
		<div class="box_txt">{{$t('imshares3')}}</div>
		<div class="box_upload" @change="onFileChange">
			<div class="fileBox cursor">
					<input class="cursor" type="file" accept="image/*">
					<img :src="imageUrl" v-if="imageUrl">
					<img v-else src="../../../assets/image/giftcard/imshareuploadicons.png" />
			</div>
							
			<div class="upload_txt">{{ $t('Please upload pictures') }}</div>
		</div>
		<div class="box_footbtns cursor" @click="submits">{{$t('Submit')}}</div>

		<div class="model" v-if="showModel" @click="showModel = false">
		<div class="model_mead" @click.stop>
		<div class="model_mead_box">
			<div class="icon" v-for="(item, index) in iconList" :key="index">
				<a href="javascript::void(0)" @click.prevent="handleShareClick(item.type)">
					<img :src="item.src">
					<div class="app-name">{{ item.name }}</div>
				</a>
			</div>
		</div>
		</div>
	</div>
	</div>
		
  </div>

</template>

<script>
import { Toast,Indicator } from 'mint-ui'
import HomeCommonSearch from '../common/HomeCommonSearch'
import { getShareGoods,uploadImg,submitShares } from '../../../api/giftcard'
export default {
  name: 'Shares',
  components: {
    HomeCommonSearch,
    
  },
  data() {
    return {
		showModel:false,
     	infos:{},
		iconList: [
		{ type: 'facebook', name: 'Facebook', src: require('../../../assets/image/giftcard/facebook.png') },
		{ type: 'telegram', name: 'Telegram', src: require('../../../assets/image/giftcard/telegram.png') },
		{ type: 'whatsapp', name: 'WhatsApp', src: require('../../../assets/image/giftcard/whatsapp.png') },
		{ type: 'instagram', name: 'Instagram', src: require('../../../assets/image/giftcard/instagram.png') },
		{ type: 'tiktok', name: 'TikTok', src: require('../../../assets/image/giftcard/tiktok.png') },
		{ type: 'youtube', name: 'YouTube', src: require('../../../assets/image/giftcard/youtube.png') },
	],
		image: null,
		imageUrl: '',
		imageVals:'',
     	
    }
  },
  mounted(){
    
    this.getInfos()
  },
  methods:{
	clickShareModel(){
        this.showModel = true;
    },
    copySuccess() {
		let share_url = this.getDomain()+'/g/'
		let str = share_url + this.infos.goods_id+'\n'+this.infos.goods_name;
		this.$copyText(str).then(
			(e) => {
				Toast(this.$t('Url Copied'))
			}, (e) => {
				Toast(this.$t('err'))
			}
		);
    },
	generateShareLink(type) {
		switch (type) {
			case 'facebook':
				return this.facebookLink();
			case 'telegram':
				return this.telegramLink();
			case 'whatsapp':
				return this.whatsappLink();
			case 'instagram':
				return `https://www.instagram.com/`;
			case 'tiktok':
				return `https://www.tiktok.com/`;
			case 'youtube':
				return `https://www.youtube.com/`;
			default:
			return '#';
		}
	},
	handleShareClick(type) {
		if (type === 'instagram' || type === 'tiktok' || type === 'youtube') {
			this.copySuccess();
			this.timer = setTimeout(() => {
				window.open(this.generateShareLink(type), '_blank');
			}, 1500);
		}else{
			window.open(this.generateShareLink(type), '_blank');
		}
	},
	facebookLink() {
		const url = this.getDomain()
		const shareUrl = encodeURIComponent(`${url}/g/${this.infos.goods_id}`);
		return `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
	},
	telegramLink() {
		const url = this.getDomain()
		const shareUrl = encodeURIComponent(`${url}/g/${this.infos.goods_id}`);
		const shareText = encodeURIComponent(this.infos.goods_name);
		return `https://t.me/share/url?url=${shareUrl}&text=${shareText}`;
	},
	whatsappLink() {
		const url = this.getDomain()
		const shareText = encodeURIComponent(`Check this out: ${url}/g/${this.infos.goods_id}\n${this.infos.goods_name}`);
		return `https://api.whatsapp.com/send?text=${shareText}`;
	},
	getDomain(){
		let hostname = window.location.hostname;
		const parts = hostname.split('.').reverse();
		if (parts.length >= 2) {
			hostname = parts[1] + '.' + parts[0];
		}
		return hostname.includes('localhost') ? 'https://share.dengshop.com' : 'https://share.'+hostname;
	},
	submits(){
        if(!this.imageVals){           
            Toast(this.$t('Please upload pictures'))
            return;
        }
        Indicator.open();
        submitShares({image:this.imageVals}).then(res=>{
            Indicator.close();
            // console.log(res)
			if(res.code == 10000){
				this.$router.push({ 'name': 'GiftCardList' });
            }else{
                Toast(res.message);
            }
            
        }).catch(function (error) {
          Indicator.close();
          Toast(error.message);
        });
    },
	onFileChange(e) {
      const file = e.target.files[0];
      if (!file) {
        return;
      }
	  Indicator.open();
      this.image = file;
      // 创建一个URL从而显示选择的图片
      this.imageUrl = URL.createObjectURL(file);
    //   console.log('图片，，，',this.imageUrl)
      // 创建FormData
      const formData = new FormData();
      formData.append('image', this.image);
      uploadImg(formData).then(res=>{
		Indicator.close();
        // console.log('resresres',res.result.file)
        this.imageVals = res.result.file
        // console.log('上传图片的地址',this.imageVals)
      }).catch(()=>{
		Indicator.close();
	  })

      
    },
    jumpShareList(){
        this.$router.push({'name': 'ShareList'})
    },
    getInfos(){
        getShareGoods().then(res=>{
            console.log(res.result)
            this.infos = res.result;
        })
    },  

  }
}
</script>

<style scoped lang="scss">
*{
	padding: 0;
	margin: 0;
	box-sizing: border-box;
}
.cursor:hover{
	cursor: pointer;
}
.model {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, .6);

	.model_mead {
		// padding-top: 15px;
		width: 100%;
		height: 150px;
		background: #fff;
		border-radius: 12px 12px 0 0;
		position: absolute;
		bottom: 0;
		left: 0;
		padding-left: 2%;
		.model_mead_box {
			display: flex;
			flex-wrap: wrap;
			.icon {
				text-align: center;
				width: 16%;
				height: 150px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					width: 40px;
					height: 40px;
				}
				.app-name{
					text-align: center;
					margin-top: 10px;
				}
			}
		}
	}
}
.box{
	width: 1200px;
	margin: 0 auto;
	
	.box_list{
		background: #fff;
		border-radius: 4px;
		display: flex;
		padding: 50px 60px;
		.box_list_lfimg{
			width: 206px;
			height: 206;
			object-fit: contain;
		}
		.box_list_rt{
			width: 460px;
			margin-left: 40px;
			.list_rt_tit{
				font-size: 18px;
				color: #000000;
				line-height: 25px;
			}
			.list_rt_txt{
				font-size: 28px;
				color: #EC5B33;
				line-height: 20px;
				padding-top: 24px;
			}
		}
		.box_list_foot{
			margin-left: 80px;
			.list_foot_btn1{
				display: inline-block;
				background: #E2B72B;
				border-radius: 4px;
				font-size: 16px;
				color: #FFFFFF;
				height: 24px;
				line-height: 24px;
				width: 120px;
				text-align: center;
				margin-right: 40px;
				overflow: hidden;
			}
			.list_foot_btn2{
				display: inline-block;
				background: #EF4618;
				border-radius: 4px;
				font-size: 16px;
				color: #FFFFFF;
				height: 24px;
				line-height: 24px;
				width: 120px;
				text-align: center;
				overflow: hidden;
			}
			.list_foot_fx{
				font-size: 18px;
				color: #000000;
				line-height: 25px;
				margin-top: 150px;
				img{
					width: 20px;
					height: 20px;
					position: relative;
					top: 2px;
				}
			}
		}
	}
	.box_tit{
		font-weight: bold;
		font-size: 18px;
		color: #000000;
		line-height: 25px;
		padding: 20px 0 15px 40px;
	}
	.box_txt{
		font-size: 14px;
		color: #000000;
		line-height: 25px;
		padding-left: 40px;
	}
	.box_upload{
		width: 244px;
		height: 96px;
		background: #FFFFFF;
		border-radius: 12px 12px 12px 12px;
		margin: 20px auto 30px;
		padding-top: 5px;
		img {
								display: block;
								width: 50px;
								height: 50px;
								margin: auto;
								object-fit: contain;
							}
		.fileBox{
			width:100px; 
			height:50px; 
			position:relative;
			margin: 0 auto;
			cursor: pointer;
			input{
				cursor: pointer;
				position:absolute;
				left:0; 
				top:-10px; 
				opacity:0; 
				font-size: 100px;
				filter:alpha(opacity=0);
				width: 100px;
				height: 100px;
				
			} 
		}
		.upload_txt{
								text-align: center;
								font-weight: bold;
								font-size: 14px;
								color: #000000;
								line-height: 30px;
								margin-top: 5px;
							}
	}
	.box_footbtns{
		background: #EF4618;
		border-radius: 4px;
		font-size: 18px;
		color: #FFFFFF;
		height: 40px;
		line-height: 40px;
		width: 160px;
		text-align: center;
		overflow: hidden;
		margin: 30px auto;
	}
}

</style>
